<template>
  <div v-if="responseData && responseData.length > 0" class="tvm-bv-confirmation mb-4">
    <div class="tvm-bv-confirmation__content d-flex">
      <div v-for="(item, index) in responseData" :key="index" class="mr-2">
        <button class="btn mb-2 rounded-buttons py-2 text-white chips__btn px-4 suggestions_btn"
          @click="optionclick(item)">
          {{ item.name }}
        </button>
      </div>
    </div>
    <div v-if="msrpDetailsData && msrpDetailsData.length > 0" class="tvm-bv-confirmation__details"
      style="display: none;">
      <AiEmailTemplate :vehicle-info="vehicleInfoData" :msrp-details="msrpDetailsData"
        :payment-collection="paymentCollectionData" :qualified-data="qualifiedIncentiviesData" />
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { usePaymentSettingsStore } from '../../../../store/PaymentSettings/PaymentsettingsStore';
import AiEmailTemplate from './AiEmailTemplate.vue';
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';

export default {
  props: {
    responseData: {
      type: Array,
      required: false
    }
  },
  mounted() {

  },
  computed: {
    ...mapState(usePaymentSettingsStore, ["paymentCollectionData", "msrpDetailsData", "qualifiedIncentiviesData", "vehicleInfoData"]),
  },
  components: {
    AiEmailTemplate
  },
  methods: {
    optionclick(item) {
      ChatWidgetService.postTvmMessage(item.name, null, null,
        item?.submitAction, null);
      try {
        if (item.submitAction === 'tvm_buyavehicle_userconfirmationyes') {
          let htmlBody = '';
          if (document.getElementById('email-quote-template')) {
            htmlBody = document.getElementById('email-quote-template').innerHTML;
            const data = ChatWidgetService.sendVehicleQuote(
              {
                accountId: window.accountId,
                campaignId: window.campaignid,
                tId: window.tid,
                htmlBody: htmlBody,
              }
            );
            console.log('Email template processed successfully:', data);
          }
        }
      } catch (error) {
        console.error('Error processing email template:', error);
      }
    }
  },
}
</script>
<style lang="">

</style>
